
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"fill":"currentColor"},style,staticStyle],
              attrs: Object.assign({"width":"96px","height":"96px","viewBox":"0 0 96 96","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","style":"fill: currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Logos-/-Confetti---Dark","stroke":"none","stroke-width":"1","fill-rule":"evenodd"}},[_c('circle',{attrs:{"id":"Oval","fill-rule":"nonzero","cx":"48","cy":"26","r":"18"}}),_c('circle',{attrs:{"id":"Oval-Copy","fill-rule":"nonzero","cx":"72","cy":"68","r":"18"}}),_c('circle',{attrs:{"id":"Oval-Copy-2","fill-rule":"nonzero","cx":"24","cy":"68","r":"18"}})])])
          )
        }
      }
    